export const RESET_CATEGORIES = 'RESET_CATEGORIES'
export const RESET_CATEGORIES_SEARCH = 'RESET_CATEGORIES_SEARCH'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_CATEGORIES_SEARCH = 'SET_CATEGORIES_SEARCH'
